export default {"src":"/_next/static/media/nl.240b177b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};